import styled from '@emotion/styled';
import {
  BREAKPOINT_MEDIUM,
  BREAKPOINT_SMALL,
  COLOR_GREEN,
} from 'client/components/MarketingPagesShared/styles';

const Section = styled.section`
  padding: 110px 36px 90px;
  color: #fff;
  background: ${COLOR_GREEN};
  h2,
  h3 {
    margin: 0;
    font-weight: 900;
  }
  h2 {
    font-size: 6rem;
    text-align: center;
  }
  h3 {
    font-size: 3.6rem;
  }
  @media (max-width: ${BREAKPOINT_MEDIUM}px) {
    padding-top: 100px;
    h2,
    h3 {
      font-size: 3.4rem;
      text-align: left;
    }
    .BrandPartners-imageSectionHeading {
      display: none;
    }
  }
  @media (max-width: ${BREAKPOINT_SMALL}px) {
    h2,
    h3 {
      font-size: 2.8rem;
    }
  }
`;

const Container = styled.div<{ flexDirectionMd?: 'column-reverse' }>`
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 1060px;
  margin: auto;
  padding: 120px 0 0;
  @media (max-width: ${BREAKPOINT_MEDIUM}px) {
    flex-direction: ${({ flexDirectionMd }) => flexDirectionMd || 'column'};
    padding: 0 0 50px;
    img,
    picture {
      padding-top: 50px;
    }
  }
  @media (max-width: 600px) {
    padding-bottom: 60px;
    img,
    picture {
      width: 100%;
    }
  }
`;

const LeftColumn = styled.div`
  flex: 0 0 431px;
  @media (max-width: ${BREAKPOINT_MEDIUM}px) {
    flex: 0;
  }
  @media (max-width: 600px) {
    width: 100%;
  }
`;

const RightColumn = styled.div`
  margin-left: 124px;
  @media (max-width: ${BREAKPOINT_MEDIUM}px) {
    width: 100%;
    margin-left: 0;
  }
`;

const TextContainer = styled.div`
  color: #fff;
  p {
    margin: 24px 0 0 0;
    color: #fff;
    font-size: 1.8rem;
  }
  @media (max-width: ${BREAKPOINT_MEDIUM}px) {
    width: 100%;
    margin: auto;
  }
`;

const CampaignBudget = styled.div`
  p {
    font-size: 1.8rem;
    line-height: 3rem;
    text-transform: uppercase;
  }
  a {
    color: #e8f524;
    font-size: 2rem;
    line-height: 4rem;
  }
`;

export {
  Container,
  Section,
  TextContainer,
  LeftColumn,
  RightColumn,
  CampaignBudget,
};
